import type { MediaLightboxItem } from "~/shared/ui/media-lightbox";
import type { Asset } from "../types";

/**
 * Маппит ассеты текущей страницы в ленту слайдов для `MediaLightbox` (карусель по
 * всему набору). Подпись слайда — имя проекта (фолбэк на имя модели). Порядок и индексы
 * совпадают с `assets`, поэтому индекс слайда лайтбокса = индекс ассета в наборе.
 */
export function toLightboxItems(assets: readonly Asset[]): MediaLightboxItem[] {
    return assets.map((a) => ({
        url: a.url,
        type: a.type,
        caption: a.projectName ?? a.modelName,
    }));
}
